export function calculateAverage(numbers: number[]) {
    if (numbers.length === 0) {
        return 0;
    }
    return numbers.reduce((curr, prev) => prev + curr, 0) / numbers.length;
}

export function nineDigitsRandomNumber() {
    return Math.floor(100000000 + Math.random() * 900000000);
}

export function getTotalAndRemainingAmount(total = 0, history: number[] = []) {
    const historyTotal = history.reduce((sum, amount) => {
        return sum + amount;
    }, 0);

    const remainingAmount = Math.max(0, total - historyTotal);

    return {
        total: historyTotal,
        remainingAmount,
    };
}

export function calculateScaledRadius(
    value: number,
    minRadius: number,
    maxRadius: number,
) {
    return Math.min(maxRadius, minRadius + Math.log10(Math.max(1, value)) * 8);
}
